// const binomenRegex = /^[A-Z][a-z]+?\s[a-z]+\.?$/

import { NotEmptyString } from '@/Domain/Shared'

export class SpeciesBinomen extends NotEmptyString {
  binomen (): string {
    return this.value()
  }
}
/*
  private _binomen: string

  constructor (binomen: string) {
    if (!binomenRegex.test(binomen)) {
      throw new TypeError(`${binomen} is not a valid Binomen`)
    }
    this._binomen = binomen
  }

  binomen (): string {
    return this._binomen
  }
}
*/
